/**
 * Extract the files from a drop event.
 *
 * `dataTransfer.files` covers files dragged from the OS file explorer. Some
 * sources — notably a desktop Outlook attachment dragged straight onto the
 * page — instead expose the file only through `dataTransfer.items` as a
 * "promised"/virtual file, so fall back to `getAsFile()` on the file-kind
 * items when the files list is empty. Must be called synchronously from the
 * `drop` handler; the data is gone afterwards. Returns an empty array when the
 * drop carried no file (e.g. a webmail attachment chip, which is only a
 * URL/HTML string).
 */
export function filesFromDrop(dataTransfer: DataTransfer): File[] {
  const fromFiles = Array.from(dataTransfer.files);
  // On a regular file drag both lists describe the same files, so only consult
  // `items` when `files` came up empty (the Outlook virtual-file case) —
  // concatenating would duplicate every file.
  if (fromFiles.length > 0) return fromFiles;
  return Array.from(dataTransfer.items)
    .map((item) => (item.kind === 'file' ? item.getAsFile() : null))
    .filter((file): file is File => file !== null);
}
